import Movie from './movie';

export default Movie;
